var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.init)?_c('div',{staticClass:"mass-add-shortlists-container",staticStyle:{"min-width":"100%"}},[_vm._v(" ooooh ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }